import React from "react";
import { FaMapMarkerAlt, FaStar } from "react-icons/fa";
import "./Hotel.css";

const Hotel = () => {
  const hotels = [
    {
      id: 1,
      name: "Grand Palace Hotel",
      location: "Bangalore, India",
      rating: 4.8,
      reviews: 245,
      image:
        "/Images/tour/hotel1.jpg",
    },
    {
      id: 2,
      name: "Ocean View Resort",
      location: "Goa, India",
      rating: 4.5,
      reviews: 132,
      image:
        "/Images/tour/hotel2.jpg",
    },
    {
      id: 3,
      name: "Mountain Retreat",
      location: "Manali, India",
      rating: 4.7,
      reviews: 98,
      image:
        "/Images/tour/hotel3.jpg",
    },
    {
      id: 4,
      name: "City Lights Hotel",
      location: "Mumbai, India",
      rating: 4.6,
      reviews: 180,
      image:
        "/Images/tour/hotel4.jpg",
    },
    {
      id: 5,
      name: "City Lights Hotel",
      location: "Mumbai, India",
      rating: 4.6,
      reviews: 180,
      image:
      "/Images/tour/hotel1.jpg",

    },
    {
      id: 6,
      name: "Grand Palace Hotel",
      location: "Bangalore, India",
      rating: 4.8,
      reviews: 245,
      image:
        "/Images/tour/hotel3.jpg",
        
    },
    {
      id: 7,
      name: "Ocean View Resort",
      location: "Goa, India",
      rating: 4.5,
      reviews: 132,
      image:
      "/Images/tour/hotel4.jpg",

    },
    {
      id: 8,
      name: "Mountain Retreat",
      location: "Manali, India",
      rating: 4.7,
      reviews: 98,
      image:
     "/Images/tour/hotel2.jpg",

    },
  ];

  return (
    <div className="hotel-listing-page">
      {/* 🔹 Banner Section with Background Image */}
      <div className="hotel-heading-section">
        <h1 className="hotel-page-heading">Our Hotels</h1>
        <p className="hotel-page-intro">
          Discover our handpicked selection of luxurious hotels across India.
          From serene beachfront resorts to vibrant city retreats, experience
          comfort, style, and unmatched hospitality at every destination. Your
          perfect getaway awaits.
        </p>
      </div>

      {/* 🔹 Hotel Cards */}
      <div className="hotel-list-grid">
        {hotels.map((hotel) => (
          <div key={hotel.id} className="hotel-card">
            <div className="hotel-image">
              <img src={hotel.image} alt={hotel.name} />
            </div>
            <div className="hotel-card-body">
              <h2>{hotel.name}</h2>
              <p className="hotel-location">
                <FaMapMarkerAlt /> {hotel.location}
              </p>
              <div className="hotel-rating">
                {[...Array(5)].map((_, i) => (
                  <FaStar
                    key={i}
                    color={i < Math.floor(hotel.rating) ? "gold" : "#ccc"}
                  />
                ))}
                <span>
                  {hotel.rating} ({hotel.reviews} reviews)
                </span>
              </div>
              <button className="book-btn">Book Now</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Hotel;
